module.exports = __webpack_public_path__ + "static/media/ausencia.147a7c82.png";